import script from "./ResourceMedia.vue?vue&type=script&setup=true&lang=js"
export * from "./ResourceMedia.vue?vue&type=script&setup=true&lang=js"

import "./ResourceMedia.vue?vue&type=style&index=0&id=5aa7fd88&scoped=true&lang=css"

import exportComponent from "/home/runner/work/logexpo/logexpo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5aa7fd88"]])

export default __exports__